import { ErrorHandler, inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '@lib/dialogs/confirm-dialog/confirm-dialog.component';

@Injectable()
export class GlobalErrorHandler extends ErrorHandler {
  matDialog = inject(MatDialog);

  handleError(error: any): void {
    const errorStr = error.toString();
    const isChunkLoadError =
      errorStr.includes('Failed to fetch dynamically imported module') || /Loading chunk .* failed/.test(errorStr);

    // Check if the error is the specific "ChunkLoadError"
    if (isChunkLoadError) {
      // Force a reload of the application
      // window.location.reload();
      const dialog = this.matDialog.open(ConfirmDialogComponent, {
        data: {
          title: 'Reload now?',
          text: 'A new version of frontend is detected and page must be reloaded. If not reloaded, webpage might not function properly.',
          saveButtonText: 'Reload',
        },
      });
      dialog.afterClosed().subscribe((result) => {
        if (result) {
          window.location.reload();
        }
      });
    } else {
      super.handleError(error);
    }
  }
}
